<template>
  <vx-card class="mt-base" :title="activityTitle">
    <centered-image-wrapper
      :image="require('@/assets/images/experiences/hairdressing/activity1.png')"
      alt="Cross-section diagram of skin showing a hair follicle. The hair shaft is made of the medulla, cortex and cuticle. Labelled parts are the sebaceous gland, arrector pili muscle, inner root sheath, outer root sheath, hair bulb, hair matrix and hair papilla."
    />
    <p class="mb-5">
      While you don’t need to understand all the science behind hair and hair growth to be a good
      hairdresser, it helps you understand some of the basics. Watch the following short video
      presentation carefully and answer the questions that follow.
    </p>

    <responsive-youtube-wrapper :video="videos[1]" :image="videoTrigger1">
      <p class="mb-5 text-center">
        <small><strong>Note:</strong> This video intentionally has no sound</small>
      </p>
    </responsive-youtube-wrapper>

    <div v-for="(question, index) in questions" :key="index">
      <h5 class="mb-5 questionlabel">{{ question.question }}</h5>
      <div class="vx-row my-5">
        <div
          class="vx-col w-full mb-2"
          v-for="(answer, index2) in question.answers"
          :key="index2"
          :class="{ wrong: !answer.correct && answers['question' + index] == answer.val }"
          v-if="isEditable"
        >
          <vs-radio
            :vs-name="'answers-question-' + index"
            v-model="answers['question' + index]"
            class="checkbox_answer multiline"
            :vs-value="answer.val"
            >{{ answer.answer }}</vs-radio
          >
        </div>
        <p
          class="my-2 mx-5"
          :class="{
            wrong: !answer.correct && answers['question' + index] == answer.val,
            correct: answer.correct && answers['question' + index] == answer.val,
          }"
          v-else
        >
          {{ answer.answer }}
        </p>
      </div>
    </div>

    <p class="mb-5">
      Remember, if you are unsure of any answers, you can go back and take another look at the video
      again.
    </p>
    <save-buttons :is-editable="isEditable" @save="save" />
  </vx-card>
</template>

<script>
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
export default {
  data() {
    return {
      videoTrigger1: require('@/assets/images/experiences/hairdressing/hair_structure_splash.jpg'),
      videos: {
        1: 'https://www.youtube.com/embed/Fms0m3vRVh4',
      },
      login_type: localStorage.getItem('login_type'),
      file: '',
      questions: {
        1: {
          question: '1. Hair is made up of a dead protein known as:',
          answers: [
            { val: 1, answer: 'Collagen', correct: false },
            { val: 2, answer: 'Casein', correct: false },
            { val: 3, answer: 'Keratin', correct: true },
          ],
        },
        2: {
          question: '2. The part of the hair seen outside the scalp is known as:',
          answers: [
            { val: 4, answer: 'The Shaft', correct: true },
            { val: 5, answer: 'The Follicle', correct: false },
            { val: 6, answer: 'The Crux', correct: false },
          ],
        },
        3: {
          question: '3. The part of the hair responsible for growth is:',
          answers: [
            { val: 7, answer: 'The Shaft', correct: false },
            { val: 8, answer: 'The Follicle', correct: true },
            { val: 9, answer: 'The Crux', correct: false },
          ],
        },
        4: {
          question: '4. Hair growth is controlled and coordinated by:',
          answers: [
            { val: 10, answer: 'Hormones', correct: true },
            { val: 11, answer: 'The Nervous System', correct: false },
            { val: 12, answer: 'The Brain', correct: false },
          ],
        },
      },
      answers: {
        question1: null,
        question2: null,
        question3: null,
        question4: null,
      },
    };
  },
  methods: {
    save() {
      this.data.question1 = JSON.stringify(this.answers);
      this.saveActivity(this.$route.params.slug, this.data, this.file, 'doc');
    },
  },
  computed: computed,
  inject: inject,
  mounted() {
    if (this.data.question1) {
      this.answers = JSON.parse(this.data.question1);
    }
  },
};
</script>

<style scoped>
.wrong {
  background: rgba(202, 20, 20, 0.24);
  border-bottom: 1px solid #f8f8f8;
  padding-top: 2px;
}
.correct {
  background: rgba(75, 202, 20, 0.24);
  border-bottom: 1px solid #f8f8f8;
}
</style>
